import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { size, map } from "lodash";
import { useAuth } from "../../../../hooks";
import { PlanesItem } from "../PlanesItem";
import { PlanesAPI } from "../../../../api";
import "./ListPlanes.scss";

const planesController = new PlanesAPI();

export function ListPlanes(props) {
  const { reload, onReload } = props;
  const { accessToken } = useAuth();

  const [planes, setPlanes] = useState(null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    limit: 1,
    page: 1,
    total: 1,
    totalDocs: 0,
  });

  useEffect(() => {
    (async () => {
      try {
        // Llamamos a getPlans pasando el token y los params
        const response = await planesController.getPlans(accessToken, {
          page,
          limit: 5,
        });
        setPlanes(response.plans);
        setPagination({
          limit: response.limit,
          page: response.page,
          total: response.totalPages,
          totalDocs: response.totalDocs,
        });
      } catch (error) {
        console.error("Error al obtener los planes:", error);
      }
    })();
  }, [page, reload, accessToken]);

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!planes) return <Loader active inline="centered" />;
  if (size(planes) === 0) return <h2>No hay planes</h2>;

  return (
    <div className="list-planes">
      {map(planes, (plan) => (
        <PlanesItem key={plan._id} plan={plan} onReload={onReload} />
      ))}

      <div className="list-planes__pagination">
        <Pagination
          totalPages={pagination.total}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
